import React, { useRef } from 'react'
import { useParams, Link } from "react-router-dom";
import All_products from '../common-components/all-products/All_products';
import Breadcrumbdata from '../common-components/breadcrumbs/Breadcrumbdata';
import './Product_description.css'
import Product_Image from './Product_Image/Product_Image'
import Product_Description from './Product_Description/Product_Description'
import Related_category from '../home/related-category/Related_category';
import Key_features from './key-features/Key_features';
import Form_component from '../contact_us/contact_form/Form_component';
import Enquire_from from './Enquire_from/Enquire_from';

const Product_description = () => {

    const enquireRef = useRef(null);

    const scrollToEnquire = () => {
        enquireRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    const { id } = useParams();
    const product = All_products.find((p) => p.id === parseInt(id));
    if (!product) {
        return <h2>Product Not Found</h2>
    }

    const breadcrumbs = [
        { label: "HOME", link: "/", active: false },
        { label: "PRODUCTS", link: "/all-products", active: false, },
        { label: "CASSIDA C300 COIN COUNTER", link: "#", active: true, },
    ];




    return (
        <>
            <section className='Product_description_sec'>
                <div className='container'>
                    <Breadcrumbdata
                    //  data={breadcrumbs}
                    />
                    <div className='product_description_container'>
                        <div className='product_information'>
                            <div className='row justify-content-center'>
                                <div className='col-lg-5 col-md-8 col-12'>
                                    <Product_Image />
                                </div>
                                <div className='col-lg-7 col-md-12'>
                                    <Product_Description scrollToEnquire={scrollToEnquire} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Key_features />

                <div className='moreformsec'>
                    <div className='container'>
                        <h4 className='morecat'>More from Category</h4>
                    </div>
                    <Related_category />
                </div>

                <div className='container' id="enquire_form" ref={enquireRef}>
                    <div className='row'>
                        <div className='col-lg-6 mx-auto' >
                            <Enquire_from />
                        </div>
                    </div>
                </div>

            </section>
        </>
    )
}






export default Product_description